module.exports = __webpack_public_path__ + "img/character.2e96f0dc.png";